/**
 * Format a EUR list amount for billing UI in the app locale: `9 €` in
 * German, `€9` in English. Whole amounts drop the decimals.
 */
export function formatEurAmount(
  amount: number,
  locale: string,
  options?: { maximumFractionDigits?: number },
): string {
  const maximumFractionDigits =
    options?.maximumFractionDigits ?? (Number.isInteger(amount) ? 0 : 2);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: maximumFractionDigits > 0 ? 2 : 0,
    maximumFractionDigits,
  }).format(amount);
}

/** Yearly list ÷ 12 for the “/ seat / month” equivalent on yearly toggle. */
export function yearlyMonthlyEquivalent(yearlyTotal: number): number {
  return Math.round((yearlyTotal / 12) * 100) / 100;
}
